import { cn } from '@/utils/index'

interface CompanyLogoPlaceholderProps {
  name?: string
  className?: string
  size?: "sm" | "md" | "lg"
}

export const CompanyLogoPlaceholder = ({ name = "Company", className, size = "md" }: CompanyLogoPlaceholderProps) => {
  // Get initials from company name
  const initials = name
    .split(" ")
    .map((word) => word[0]?.toUpperCase() || "")
    .slice(0, 2)
    .join("")

  // Generate a consistent color based on company name
  const colors = [
    "bg-blue-500 text-white",
    "bg-green-500 text-white",
    "bg-purple-500 text-white",
    "bg-amber-500 text-white",
    "bg-rose-500 text-white",
    "bg-indigo-500 text-white",
  ]
  const colorIndex = name.split("").reduce((sum, char) => sum + char.charCodeAt(0), 0) % colors.length
  const colorClass = colors[colorIndex]

  const sizeClasses = {
    sm: "w-8 h-8 text-xs",
    md: "w-12 h-12 text-sm",
    lg: "w-16 h-16 text-base",
  }

  return (
    <div
      className={cn("flex items-center justify-center rounded-lg font-bold", colorClass, sizeClasses[size], className)}
    >
      {initials}
    </div>
  )
}
